export default {"src":"/_next/static/media/left-arrow.a61d839a.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};